/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WarehouseOpsDisposeDtoCreate } from '../../models/warehouse-ops-dispose-dto-create';

export interface WarehouseControllerCreateDispose$Params {
      body: WarehouseOpsDisposeDtoCreate
}

export function warehouseControllerCreateDispose(http: HttpClient, rootUrl: string, params: WarehouseControllerCreateDispose$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, warehouseControllerCreateDispose.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

warehouseControllerCreateDispose.PATH = '/warehouse/dispose';
